export default __webpack_public_path__ + "static/media/hero.1c650f57.jpg";